<div class="no-results-message">
    <div class="main" trans>No matches found.</div>
    <div class="secondary" trans>Try another search with different query or file type.</div>
    <mat-icon svgIcon="search-custom" class="icon"></mat-icon>
</div>